import React from 'react';

import { Typography, Paper, List, ListItem } from '@material-ui/core';
import { keys } from 'ramda';

import { useOIDBalanceReports } from 'hooks/api/useOIDBalanceReports';

import useStyles from 'pages/OIDBalanceSuccessorBorrowerDetails/useStyles';

const TITLE = 'Journal Entry';

export const JournalEntry = () => {
  const { successorBorrowerReport, SBJournalEntryTableFields } = useOIDBalanceReports();
  const classes = useStyles();

  return (
    <div>
      <Typography className={classes.listTitle}>{TITLE}</Typography>
      <Paper className={classes.listWrap}>
        <List className={classes.list}>
          {keys(SBJournalEntryTableFields).map((key, index) => {
            const { displayedName } = SBJournalEntryTableFields[key];
            const data = successorBorrowerReport[key];
            return (
              <ListItem className={classes.listItem} key={`summary-${index}`}>
                <Typography className={classes.bodyBold}>{displayedName}</Typography>
                <Typography className={classes.body1}>{data}</Typography>
              </ListItem>
            );
          })}
        </List>
      </Paper>
    </div>
  );
};
